import { UserListItem } from 'src/common-services'

export const getUserListItemTitle = (item: UserListItem) => {
  switch (item.type) {
    case 'location':
      return item.data.name
    case 'place':
      return item.data.address || item.data.name
    case 'custom-area':
      return item.data.name
    case 'parcel':
      return item.data.address || item.data.properties?.addr
    case 'owner':
      return item.data.name
  }
}

export const getUserListItemSubtitle = (item: UserListItem) => {
  switch (item.type) {
    case 'location':
      return item.data.address
    case 'place':
      return null
    case 'custom-area':
      return item.data.description
    case 'parcel':
      return item.data.address || item.data.properties?.addr
    case 'owner':
      return item.data.name
  }
}
